<!-- new theme implementation starts -->
<div class="subheader with-padding flgrow">
  <div class="row">
    <div
      class="col-lg-3 col-md-6 col-sm-8"
      *ngIf="userList && userList?.length > 0"
    >
      <div class="relative flmid">
        <div class="flgrow">
          <ng-select
            class="w-100"
            placeholder="{{ 'lblSelectUser' | translate }}"
            [(ngModel)]="userId"
            name="userId"
            (change)="onUserChange()"
            (keyup.enter)="onSearch()"
          >
            <ng-option *ngFor="let user of userList" [value]="user.userId">
              {{ user.name }}
            </ng-option>
          </ng-select>
        </div>
      </div>
      <p *ngIf="isRequired" class="help-block text-danger" translate>
        lblRequiredDealer
      </p>
    </div>
    <div class="col-auto ml-auto" *ngIf="userId">
      <button type="button" (click)="exportAsXLSX()"
          ngbTooltip="{{'lblExportExcel' | translate}}" placement="bottom" aria-label="Center Align">
          <img src="./../../../assets/images/excel.png" height="32" width="32" alt="" />
      </button> 
      <a
        class="ml-2 btn btn-outline-primary"
        (click)="onRefresh()"
        aria-label="Center Align"
      >
        <em class="fas fa-sync fa-lg"></em>
      </a>
    </div>
  </div>
</div>
<div class="container prel" *ngIf="userId">
  <div class="card" *ngIf="userList?.length > 0; else load_else">
    <div class="card-body pb-0">
      <ng-container>
        <app-af-mechanic-scheduler-list
          [schedularHeader]="schedulerHeaderInfo"
          (onMonthChange)="scheduleSummaryMonthChange($event)"
          (viewDetails)="viewDetails(userStampSummary, $event)"
          [isScheduleSummary]="true"
          [isUsedForUser]="true"
          [dealerName]="dealerName"
          [selectedDate]="selectedDate"
          [mechanicData]="userData"
        >
        </app-af-mechanic-scheduler-list>
      </ng-container>
    </div>
  </div>
  <ng-template #load_else>
    <div class="card" *ngIf="isMechanicNotAssociated">
      <div class="card-body pb-0">
        <ng-container>
          <div class="alert alert-danger text-center mx-3">
            <span class="font18">
              {{ "lblSetMechanicShift" | translate }}
            </span>
          </div>
        </ng-container>
      </div>
    </div>
  </ng-template>
  <ng-container *ngIf="isSearched && mechanicData.length > 0">
    <ul class="list-inline mt-3 d-flex justify-content-end">
      <li class="list-inline-item align-items-center">
        <strong
          class="color-bg align-middle"
          style="background-color: #bee7ac"
        ></strong>
        <span class="align-middle" translate>lblMechanicAvailable</span>
      </li>

      <li class="list-inline-item align-items-center ml-3">
        <strong
          class="color-bg align-middle"
          style="background-color: #bfc2b7"
        ></strong>
        <span class="align-middle" translate>lblMechanicisNotAvailable</span>
      </li>
    </ul>
  </ng-container>
</div>
<ng-template #userStampSummary let-modal>
  <div class="modal-header">
    <h2 class="modal-title" translate>lblViewSummary</h2>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="modal.dismiss('Cross click')"
    >
      <span aria-hidden="true"> × </span>
    </button>
  </div>
  <div class="modal-body p-0">
    <div
      class="d-flex align-items-center w-100 flex-column"
      style="margin-top: 10px"
    >
      <div class="d-flex align-items-center">
        <div class="mr-2" style="font-size: large; font-weight: 700">
          {{ userName }}
        </div>
      </div>
      <div class="d-flex align-items-center">
        <div
          class="month-Year-child card-header text-center"
          *ngIf="selectedDay"
        >
          {{ selectedDay }}
        </div>
      </div>
    </div>
    <div class="table-responsive max-h50">
      <table class="tablest1">
        <thead class="stick-header">
          <tr>
            <th style="width: 20%" scope="col" translate>lblTimeFrom</th>
            <th style="width: 20%" scope="col" translate>lblTimeTo</th>
            <th style="width: 20%" scope="col" translate>lblComment</th>
          </tr>
        </thead>
        <tbody>
          <ng-container
            *ngIf="userClockInOutList?.length > 0; else load_NotFound_Template"
          >
            <tr
              *ngFor="let userClockInOut of userClockInOutList; let i = index"
            >
              <td>
                <div *ngIf="userClockInOut.stampIn">
                  {{ userClockInOut.stampIn | date : "HH:mm" }}
                </div>
                <div *ngIf="userClockInOut.stampIn == null">-</div>
              </td>
              <td>
                <div *ngIf="userClockInOut.stampOut">
                  {{ userClockInOut.stampOut | date : "HH:mm" }}
                </div>
                <div *ngIf="userClockInOut.stampOut == null">-</div>
              </td>
              <td>
                <ngb-highlight [result]="userClockInOut.comment">
                </ngb-highlight>
              </td>
            </tr>
          </ng-container>
          <ng-template #load_NotFound_Template>
            <tr>
              <td colspan="3" class="text-center" translate>lblNoRecordsFound</td>
            </tr>
          </ng-template>
        </tbody>
      </table>
    </div>
  </div>
  <div class="modal-footer">
    <button
      class="btn btn-primary mr-sm-2 mb-1"
      type="button"
      aria-label="Center Align"
      (click)="modal.dismiss('Cross click')"
      translate
    >
      lblClose
    </button>
  </div>
</ng-template>
<!-- new theme implementation ends -->
